import script from "./ProjectSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectSection.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectSection.vue?vue&type=style&index=0&id=454e269a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-454e269a"]])

export default __exports__